import { render } from "./AddBanner.vue?vue&type=template&id=f922eb5e&scoped=true"
import script from "./AddBanner.vue?vue&type=script&lang=js"
export * from "./AddBanner.vue?vue&type=script&lang=js"

import "./AddBanner.vue?vue&type=style&index=0&id=f922eb5e&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f922eb5e"]])

export default __exports__